export default (array) => {
    const obj = {};

    array.forEach((item) => {
        obj[item] = {
            get() {
                if (this.userOptions[item].length == 0) {
                    return "";
                }

                return this.userOptions[item][0];
            },
            set(value) {
                this.$store.dispatch("UsedSearchOptions/updateOptions", {
                    [item]: [value]
                });
            }
        }
    })

    return obj;
}



// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/used-search-options/ComputedArrayStringBinding.js